import ResetPass from "./ResetPass.jsx";
export default ResetPass;